import React from "react";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { useAdminDashboard } from "@/features/admin/hooks";
import { useDashboardWarningsQuery } from "@/features/admin/features/dashboards/hooks/queries";
import { toUpdateWarningSettings } from "@/features/admin/features/dashboards/components/warnings-dialog-box/warning-settings.utils";

import EditWarningsMenu from "./edit-warnings-menu";
import {
  isLegacyDashboardWarningSettingKey,
  LegacyDashboardWarningSettingKey,
} from "./legacy-warning-setting-keys";
import { WarningBox, WarningItem, WarningTitle } from "./styled";

const WarningType: Record<LegacyDashboardWarningSettingKey, string> = {
  warnings_water_authorities: "Waterkeringen waarschuwingen",
  warnings_provinces: "Provincie waarschuwingen",
};

const WarningData = () => {
  const dashboard = useAdminDashboard();
  const warningQuery = useDashboardWarningsQuery(dashboard.id);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [warning, setWarning] = React.useState<LegacyDashboardWarningSettingKey | null>(
    null,
  );

  if (!dashboard || !warningQuery.data) return null;

  const filteredData = Object.entries(warningQuery.data)
    .filter(
      ([key, value]) =>
        isLegacyDashboardWarningSettingKey(key) && value !== null && value.length > 0,
    )
    .map(([key, value]) => ({ [key]: value }));

  return (
    <>
      {filteredData.map((warningEntry, index) => {
        const selectedWarningKey = Object.keys(
          warningEntry,
        )[0] as LegacyDashboardWarningSettingKey;
        const selectedWarningType = WarningType[selectedWarningKey];

        return (
          <WarningBox key={index}>
            <WarningTitle>{selectedWarningType}</WarningTitle>
            {Object.values(warningEntry)[0]?.map((item: string, itemIndex: number) => {
              const transformItem = item.replace(/_/g, " ");
              return <WarningItem key={itemIndex}>{transformItem}</WarningItem>;
            })}
            <IconButton
              aria-label="edit"
              size="small"
              onClick={(e) => {
                setAnchorEl(e.currentTarget);
                setWarning(selectedWarningKey);
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </WarningBox>
        );
      })}
      <EditWarningsMenu
        anchorEl={anchorEl}
        warning={warning}
        allWarnings={toUpdateWarningSettings(warningQuery.data)}
        onClose={() => {
          setAnchorEl(null);
          setWarning(null);
        }}
      />
    </>
  );
};

export default WarningData;
